/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FolderStructure } from '../../models/folder-structure';

export interface FolderControllerGetFolderStructure$Params {
}

export function folderControllerGetFolderStructure(http: HttpClient, rootUrl: string, params?: FolderControllerGetFolderStructure$Params, context?: HttpContext): Observable<StrictHttpResponse<FolderStructure>> {
  const rb = new RequestBuilder(rootUrl, folderControllerGetFolderStructure.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FolderStructure>;
    })
  );
}

folderControllerGetFolderStructure.PATH = '/folder/structure';
